import React from "react";
import { useI18n } from "../../i18n/I18nContext";
import { Select, MenuItem, Box, Typography } from "@mui/material";

export default function LanguageSwitcher() {
    const { lang, setLang } = useI18n();

    const handleChange = (event) => {
        setLang(event.target.value);
    };

    const flags = {
        de: "/flags/de.svg",
        en: "/flags/en.svg",
        fr: "/flags/fr.svg",
        it: "/flags/it.svg",
    };

    return (
        <Select
            value={lang}
            onChange={handleChange}
            size="small"
            MenuProps={{ disableScrollLock: true }}
            sx={{
                ml: 2,
                minWidth: 110,
                "& .MuiSelect-select": {
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                },
            }}
        >
            {Object.entries(flags).map(([code, flag]) => (
                <MenuItem
                    key={code}
                    value={code}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <Box
                        component="img"
                        src={flag}
                        alt={code}
                        sx={{ width: 20, height: 14, borderRadius: "2px" }}
                    />
                    <Typography sx={{ fontSize: "0.9rem" }}>
                        {code.toUpperCase()}
                    </Typography>
                </MenuItem>
            ))}
        </Select>
    );
}
